


































import { Component as NodeComponent } from 'vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { EntryAllCfg, EntryHomeCardListMap, PropsalTabsObj, PropsalTabsListMap } from '@/types/newPersion'
@Component
export default class PropsalPage extends Vue {
  @Prop() entryAllCfg!: EntryAllCfg;
  @Prop() getTopChartAndTableFn!: Function;
  type: string | null = null;
  settingPage: NodeComponent | null = null;
  settingPageParams: {} | null = null
  settingPageEvent: {} | null = null

  getEntryInfo (): EntryHomeCardListMap {
    const { entryPageCfg, homeCardList } = this.entryAllCfg
    return (homeCardList.find((w) => w.type === entryPageCfg?.type) as unknown as EntryHomeCardListMap)
  }

  // 右侧按钮文案
  rightTabBtnText () {
    let btnText = '添加产品'
    const _1obj = (this.getEntryInfo().propsalTabsObj as PropsalTabsObj)
    const find = _1obj.propsalTabsList.find((item: PropsalTabsListMap) => item.type === _1obj.type)
    if (find?.rightTabBtnAlias) {
      btnText = find.rightTabBtnAlias
    }
    return btnText
  }

  private handleAddSettingPage (page: NodeComponent | null = null, params: {} | null = null) {
    this.settingPageParams = params
    this.settingPageEvent = params ? { 'on-click': this.handleClick, 'on-edit-btn': this.handleEditBtn } : null
    this.settingPage = page
  }

  private handleClick (type: string) {
    this.settingPage = this.settingPageParams = this.settingPageEvent = null
    this.type = type
  }

  private handleEditBtn (status: string, idx: number) {
    this.$emit('on-edit-btn', status, idx)
  }
}
